import { useState, useCallback } from 'react'

export function useCarrito() {
  const [items, setItems] = useState([])

  // Para productos por peso: agregar(producto, { kg, precioFinal })
  // Para productos por pieza: agregar(producto) o agregar(producto, 1)
  const agregar = useCallback((producto, cantidadOrPeso = 1) => {
    setItems(prev => {
      const existente = prev.find(i => i._id === producto._id)

      if (producto.unidad === 'kg') {
        // cantidadOrPeso es { kg, precioFinal }
        const { kg, precioFinal } = typeof cantidadOrPeso === 'object'
          ? cantidadOrPeso
          : { kg: cantidadOrPeso, precioFinal: null }

        const nuevoItem = { ...producto, cantidad: kg ?? 0, precioFinal }
        if (existente) {
          return prev.map(i => i._id === producto._id ? nuevoItem : i)
        }
        return [...prev, nuevoItem]
      }

      // Por pieza
      const cantidad = typeof cantidadOrPeso === 'number' ? cantidadOrPeso : 1
      if (existente) {
        return prev.map(i =>
          i._id === producto._id ? { ...i, cantidad: i.cantidad + cantidad } : i
        )
      }
      return [...prev, { ...producto, cantidad }]
    })
  }, [])

  const quitar = useCallback((productoId) => {
    setItems(prev => {
      const existente = prev.find(i => i._id === productoId)
      if (!existente) return prev
      if (existente.unidad === 'kg' || existente.cantidad <= 1) {
        return prev.filter(i => i._id !== productoId)
      }
      return prev.map(i => i._id === productoId ? { ...i, cantidad: i.cantidad - 1 } : i)
    })
  }, [])

  const eliminarItem = useCallback((productoId) => {
    setItems(prev => prev.filter(i => i._id !== productoId))
  }, [])

  const vaciar = useCallback(() => setItems([]), [])

  // Para kg con precioFinal: usar ese precio; si no, precio × cantidad
  const total = items.reduce((sum, i) =>
    sum + (i.precioFinal != null ? i.precioFinal : i.precio * i.cantidad), 0
  )
  const cantidadTotal = items.reduce((sum, i) => sum + (i.unidad === 'kg' ? 1 : i.cantidad), 0)

  return { items, agregar, quitar, eliminarItem, vaciar, total, cantidadTotal }
}
